import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-metering-hierarchy',
  templateUrl: './summary-metering-hierarchy.component.html',
  styleUrls: ['./summary-metering-hierarchy.component.scss']
})
export class SummaryMeteringHierarchyComponent {

  constructor() { }
}
